const defaultAttributes =  [
    {
        key: 'A', 
        body: 'Your Intimate or Romantic Relationships', 
        subtext: '(e.g., as reflected in the level of closeness you feel in close relationships', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'B', 
        body: 'Your Body Weight', 
        subtext: '(e.g., your actual current weight)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'C', 
        body: 'Your Body Shape', 
        subtext: '(e.g., your actual current shape, the way your clothes fit)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'D', 
        body: 'Your Muscularity', 
        subtext: '(e.g., your actual muscle size, tone, etc.)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'E', 
        body: 'Your Competence at School/Work', 
        subtext: '(e.g., as reflected by grades or work evaluation)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'F', 
        body: 'Your Personality', 
        subtext: '(e.g., warmth, level-headedness, openness, self-control)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'G', 
        body: 'Your Friendships', 
        subtext: '(e.g., as reflected by the number or quality of friendships)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'H', 
        body: 'Your Face', 
        subtext: '(e.g., how "good looking" you are)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'I', 
        body: 'Your Personal Development', 
        subtext: '(e.g., your sense of morality, ethics, or spirituality)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
    {
        key: 'J', 
        body: 'Your competence at activities other than school/work', 
        subtext: '(e.g., your competence in music, sports, hobbies)', 
        value: 0, 
        default: true, 
        selected:false, 
        removed:false
    },
]

export default defaultAttributes